// hooks/useNotificationSound.js
import { useRef } from "react";

export function useNotificationSound() {
  const audioRef = useRef(null);

  if (!audioRef.current && typeof Audio !== "undefined") {
    audioRef.current = new Audio("/notification-sound.mp3");
  }

  const playSound = () => {
    try {
      audioRef.current?.play();
    } catch (error) {
      console.error("Sound play failed:", error);
    }
  };

  return playSound;
}
